<template>
  <div id="about">
    <Navbar />

    <div class="container">
      <h1 class="mb-4">About Frizlen</h1>
      <!-- /.CARDS -->
      <b-card-group columns>
        <!-- /.CARD -->
        <b-card
          @click="showAboutPage = true"
          :title="'Company'"
          :img-src="'/static/slides/slide_4.jpg'"
          img-alt="'Architectural Image'"
          img-top
          class="clickable"
        >
          <b-card-text>
            Learn about the Frizlen Group.
          </b-card-text>
        </b-card>
        <router-link :to="{ name: 'Team'}">
          <b-card
            :to="{ name: 'Team'}"
            :title="'Team'"
            :img-src="'/static/slides/slide_1.jpg'"
            img-alt="'Architectural Image'"
            img-top
            class="clickable"
          >
            <b-card-text>
              Meet the Frizlen team.
            </b-card-text>
          </b-card>
        </router-link>
        <b-card
          @click="showContactPage = true"
          :title="'Contact'"
          :img-src="'/static/slides/slide.jpg'"
          img-alt="'Architectural Image'"
          img-top
          class="clickable"
        >
          <b-card-text>
            Contact the Frizlen Group.
          </b-card-text>
        </b-card>
      </b-card-group>
    </div><!-- /.container -->

    <!-- ABOUT MODAL -->
    <div class="o-modal" v-if="showAboutPage == true">
      <div class="o-modal-content big">
        <div class="o-modal-header">
          <a
            @click="showAboutPage = false"
            class="close clickable"
          ><i class="fas fa-times"></i></a>
          <p class="lead">About Frizlen Group</p>
        </div><!-- /.o-modal-header -->
        <div class="o-modal-body">
          <div class="row">
            <div class="col-md-6">
              <img class="w-100" src="/static/slides/slide_4.jpg" />
            </div><!-- /.col-md-4 -->
            <div class="col-md-6" v-html="aboutPage.attributes.body.value">
            </div><!-- /.col-md-8 -->
          </div><!-- /.row -->
        </div><!-- /.o-modal-body -->
      </div><!-- /.o-modal-content -->
    </div><!-- /.o-modal -->

    <!-- ABOUT MODAL -->
    <div class="o-modal" v-if="showContactPage == true">
      <div class="o-modal-content big">
        <div class="o-modal-header">
          <a
            @click="showContactPage = false"
            class="close clickable"
          ><i class="fas fa-times"></i></a>
          <p class="lead">Contact Frizlen Group</p>
        </div><!-- /.o-modal-header -->
        <div class="o-modal-body">
          <div
            v-html="contactPage.attributes.body.value"
          ></div>
        </div><!-- /.o-modal-body -->
      </div><!-- /.o-modal-content -->
    </div><!-- /.o-modal -->


    <transition name="fade">
      <div
        v-if="loading == true"
        class="spinner d-flex justify-content-center mb-3"
      >
        <b-spinner style="width: 5rem; height: 5rem;" label="Loading..."></b-spinner>
      </div>
    </transition>
  </div><!-- /#about -->
</template>

<script>
import Navbar from './Navbar'
import axios from 'axios'

export default {
  data() {
    return {
      loading: true,
      aboutPage: {},
      showAboutPage: false,
      contactPage: {},
      showContactPage: false
    }
  },
  components: {
    Navbar
  },
  created() {
    this.getPages()
  },
  methods: {
    getPages () {
      axios.get('https://buffalofts.com/jsonapi/node/frizlen_page/2394030e-2734-4504-bbc3-773505eba97a').then(response => {
        this.aboutPage = response.data.data
      })
      axios.get('https://buffalofts.com/jsonapi/node/frizlen_page/ac042712-800a-4160-be1c-a921dcd084f6').then(response => {
        this.contactPage = response.data.data
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
#about {
  background: url(/static/backgrounds/portfolio.jpg) no-repeat center center fixed;
  background-size: cover;
  padding-top: 100px;
  min-height: 100vh;
  position: relative;
}

.card {
  color: #333;
}

/* ONLY ON LARGE SCREENS */
@media(min-width:600px) {
  .card {
    transition: all 0.2s ease-in-out;
    transform: scale(0.95);
  }
  .card:hover {
    box-shadow: 2px 3px 8px rgba(255,255,255,0.3);
    transform: scale(1);
  }

  .card img {
    transition: all 0.5s ease-in-out;
    filter: grayscale(0.85);
  }
  .card:hover img {
    filter: grayscale(0);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/About.vue